import type { LocaleMessageBundle } from '../../types'

export const hrmProfileMessages: LocaleMessageBundle = {
  vi: {
    'staff.profile.title': 'Hồ sơ nhân sự',
    'staff.profile.backToList': 'Danh sách nhân viên',
    'staff.profile.loadFailed': 'Không tải được hồ sơ nhân sự.',
    'staff.profile.detail.workSection': 'Thông tin công việc',
    'staff.profile.detail.systemSection': 'Thông tin hệ thống',
    'staff.profile.detail.navigationTitle': 'Điều hướng hồ sơ',
    'staff.profile.detail.createdAt': 'Ngày tạo',
    'staff.profile.detail.updatedAt': 'Ngày cập nhật',
    'staff.profile.detail.yes': 'Có',
    'staff.profile.detail.no': 'Không',
    'staff.profile.detail.compensationSection': 'Lương & phụ cấp',
    'staff.profile.detail.allowances': 'Phụ cấp',
    'staff.profile.detail.healthInsurance': 'Bảo hiểm y tế',
    'staff.profile.detail.unemploymentInsurance': 'Bảo hiểm thất nghiệp',
    'staff.profile.tab.personal': 'Thông tin cá nhân',
    'staff.profile.tab.identityDocuments': 'Giấy tờ định danh',
    'staff.profile.tab.addresses': 'Địa chỉ',
    'staff.profile.tab.emergencyContacts': 'Người liên hệ khẩn cấp',
    'staff.profile.tab.familyMembers': 'Gia đình',
    'staff.profile.tab.bankAccounts': 'Tài khoản ngân hàng',
    'staff.profile.tab.taxInsurance': 'Thuế & BHXH',
    'staff.profile.tab.documents': 'Tài liệu',
    'staff.profile.tab.consents': 'Xác nhận dữ liệu',

    'staff.profile.actions.add': 'Thêm',
    'staff.profile.actions.edit': 'Sửa',
    'staff.profile.actions.delete': 'Xóa',
    'staff.profile.actions.verify': 'Xác minh',
    'staff.profile.actions.verified': 'Đã xác minh',
    'staff.profile.actions.refresh': 'Làm mới',
    'staff.profile.actions.save': 'Lưu',
    'staff.profile.actions.savePersonal': 'Lưu thông tin cá nhân',
    'staff.profile.actions.saveTax': 'Lưu thông tin thuế',
    'staff.profile.actions.saveInsurance': 'Lưu thông tin BHXH',
    'staff.profile.actions.addTitle.identity_documents': 'Thêm giấy tờ định danh',
    'staff.profile.actions.editTitle.identity_documents': 'Cập nhật giấy tờ định danh',
    'staff.profile.actions.addTitle.addresses': 'Thêm địa chỉ',
    'staff.profile.actions.editTitle.addresses': 'Cập nhật địa chỉ',
    'staff.profile.actions.addTitle.emergency_contacts': 'Thêm người liên hệ khẩn cấp',
    'staff.profile.actions.editTitle.emergency_contacts': 'Cập nhật người liên hệ khẩn cấp',
    'staff.profile.actions.addTitle.family_members': 'Thêm thành viên gia đình',
    'staff.profile.actions.editTitle.family_members': 'Cập nhật thành viên gia đình',
    'staff.profile.actions.addTitle.bank_accounts': 'Thêm tài khoản ngân hàng',
    'staff.profile.actions.editTitle.bank_accounts': 'Cập nhật tài khoản ngân hàng',
    'staff.profile.actions.addTitle.documents': 'Thêm tài liệu',
    'staff.profile.actions.editTitle.documents': 'Cập nhật tài liệu',
    'staff.profile.actions.addTitle.consents': 'Thêm xác nhận',
    'staff.profile.actions.editTitle.consents': 'Cập nhật xác nhận',
    'staff.profile.actions.deleteConfirm.identity_documents': 'Xóa giấy tờ định danh này?',
    'staff.profile.actions.deleteConfirm.addresses': 'Xóa địa chỉ này?',
    'staff.profile.actions.deleteConfirm.emergency_contacts': 'Xóa người liên hệ khẩn cấp này?',
    'staff.profile.actions.deleteConfirm.family_members': 'Xóa thành viên gia đình này?',
    'staff.profile.actions.deleteConfirm.bank_accounts': 'Xóa tài khoản ngân hàng này?',
    'staff.profile.actions.deleteConfirm.documents': 'Xóa tài liệu này?',
    'staff.profile.actions.deleteConfirm.consents': 'Xóa xác nhận này?',
    'staff.profile.actions.verifyConfirm.identity_documents':
      'Xác nhận giấy tờ định danh này đã đúng?',
    'staff.profile.actions.verifyConfirm.bank_accounts':
      'Xác nhận tài khoản ngân hàng này đã đúng?',
    'staff.profile.actions.verifyConfirm.documents': 'Xác nhận tài liệu này đã đúng?',

    'staff.profile.common.isPrimary': 'Đặt làm chính',
    'staff.profile.common.primary': 'Chính',
    'staff.profile.common.notPrimary': 'Phụ',
    'staff.profile.common.verifiedAt': 'Xác minh lúc',
    'staff.profile.common.empty': 'Chưa có dữ liệu',
    'staff.profile.common.required': 'Trường này là bắt buộc.',

    'staff.profile.personal.legalName': 'Họ tên pháp lý',
    'staff.profile.personal.firstName': 'Tên',
    'staff.profile.personal.lastName': 'Họ',
    'staff.profile.personal.placeOfBirth': 'Nơi sinh',
    'staff.profile.personal.maritalStatus': 'Tình trạng hôn nhân',
    'staff.profile.personal.maritalStatus.single': 'Độc thân',
    'staff.profile.personal.maritalStatus.married': 'Đã kết hôn',
    'staff.profile.personal.maritalStatus.divorced': 'Ly hôn',
    'staff.profile.personal.maritalStatus.widowed': 'Góa',
    'staff.profile.personal.nationality': 'Quốc tịch',
    'staff.profile.personal.ethnicity': 'Dân tộc',
    'staff.profile.personal.religion': 'Tôn giáo',
    'staff.profile.personal.personalEmail': 'Email cá nhân',
    'staff.profile.personal.personalPhone': 'Điện thoại cá nhân',
    'staff.profile.personal.note':
      'Dữ liệu liên hệ cá nhân được mã hoá trước khi lưu vào hệ thống.',
    'staff.profile.personal.fillFromGeneral': 'Lấy từ thông tin chung',

    'staff.profile.identity.documentType': 'Loại giấy tờ',
    'staff.profile.identity.documentType.CCCD': 'Căn cước công dân',
    'staff.profile.identity.documentType.CMND': 'CMND',
    'staff.profile.identity.documentType.PASSPORT': 'Hộ chiếu',
    'staff.profile.identity.documentType.OTHER': 'Khác',
    'staff.profile.identity.documentNumber': 'Số giấy tờ',
    'staff.profile.identity.fullNameOnDocument': 'Họ tên trên giấy tờ',
    'staff.profile.identity.dateOfBirthOnDocument': 'Ngày sinh trên giấy tờ',
    'staff.profile.identity.genderOnDocument': 'Giới tính trên giấy tờ',
    'staff.profile.identity.issueDate': 'Ngày cấp',
    'staff.profile.identity.expiryDate': 'Ngày hết hạn',
    'staff.profile.identity.issuePlace': 'Nơi cấp',
    'staff.profile.identity.issuingAuthority': 'Cơ quan cấp',
    'staff.profile.identity.frontUrl': 'Ảnh mặt trước',
    'staff.profile.identity.backUrl': 'Ảnh mặt sau',
    'staff.profile.identity.validation.expiryAfterIssue': 'Ngày hết hạn phải từ ngày cấp trở đi',
    'staff.profile.identity.validation.documentNumber':
      'Số giấy tờ chỉ gồm chữ, số, dấu gạch và dấu chấm',
    'staff.profile.identity.attachments': 'Ảnh đính kèm',
    'staff.profile.identity.upload.addPhoto': 'Thêm ảnh',
    'staff.profile.identity.upload.select': 'Chọn ảnh',
    'staff.profile.identity.upload.replace': 'Đổi ảnh',
    'staff.profile.identity.upload.clear': 'Gỡ ảnh',
    'staff.profile.identity.upload.invalidType': 'Chỉ hỗ trợ ảnh JPG, PNG, WEBP',
    'staff.profile.identity.upload.fileTooLarge': 'Mỗi ảnh tối đa {max}MB',
    'staff.profile.identity.upload.totalTooLarge': 'Tổng dung lượng ảnh vượt quá {max}MB',
    'staff.profile.identity.upload.maxFiles': 'Tối đa {max} ảnh',
    'staff.profile.identity.upload.failed': 'Tải ảnh lên thất bại, vui lòng thử lại',

    'staff.profile.address.addressType': 'Loại địa chỉ',
    'staff.profile.address.addressType.PERMANENT': 'Thường trú',
    'staff.profile.address.addressType.CURRENT': 'Hiện tại',
    'staff.profile.address.addressType.MAILING': 'Nhận thư',
    'staff.profile.address.addressType.OTHER': 'Khác',
    'staff.profile.address.addressLine': 'Địa chỉ chi tiết',
    'staff.profile.address.ward': 'Phường/xã',
    'staff.profile.address.district': 'Quận/huyện',
    'staff.profile.address.province': 'Tỉnh/thành phố',
    'staff.profile.address.country': 'Quốc gia',
    'staff.profile.address.postalCode': 'Mã bưu chính',
    'staff.profile.address.effectiveFrom': 'Hiệu lực từ',
    'staff.profile.address.effectiveTo': 'Hiệu lực đến',
    'staff.profile.address.validation.effectiveRange':
      'Ngày hiệu lực đến phải từ ngày hiệu lực từ trở đi',
    'staff.profile.address.validation.postalCode': 'Mã bưu chính chỉ gồm số',

    'staff.profile.emergency.fullName': 'Họ tên',
    'staff.profile.emergency.relationship': 'Mối quan hệ',
    'staff.profile.emergency.phone': 'Số điện thoại',
    'staff.profile.emergency.alternatePhone': 'Số điện thoại phụ',
    'staff.profile.emergency.email': 'Email',
    'staff.profile.emergency.address': 'Địa chỉ',
    'staff.profile.emergency.priority': 'Thứ tự ưu tiên',
    'staff.profile.emergency.notes': 'Ghi chú',

    'staff.profile.family.fullName': 'Họ tên',
    'staff.profile.family.relationship': 'Mối quan hệ',
    'staff.profile.family.gender': 'Giới tính',
    'staff.profile.family.dateOfBirth': 'Ngày sinh',
    'staff.profile.family.nationality': 'Quốc tịch',
    'staff.profile.family.occupation': 'Nghề nghiệp',
    'staff.profile.family.phone': 'Số điện thoại',
    'staff.profile.family.address': 'Địa chỉ',
    'staff.profile.family.isDependent': 'Là người phụ thuộc',
    'staff.profile.family.dependentFrom': 'Phụ thuộc từ',
    'staff.profile.family.dependentTo': 'Phụ thuộc đến',
    'staff.profile.family.notes': 'Ghi chú',
    'staff.profile.family.validation.dependentRange':
      'Ngày phụ thuộc đến phải từ ngày phụ thuộc từ trở đi',

    'staff.profile.bank.bankName': 'Tên ngân hàng',
    'staff.profile.bank.bankCode': 'Mã ngân hàng',
    'staff.profile.bank.branchName': 'Chi nhánh',
    'staff.profile.bank.accountNumber': 'Số tài khoản',
    'staff.profile.bank.accountHolderName': 'Tên chủ tài khoản',
    'staff.profile.bank.currency': 'Loại tiền',
    'staff.profile.bank.validation.accountNumber': 'Số tài khoản chỉ gồm số',

    'staff.profile.tax.taxIdentificationNumber': 'Mã số thuế',
    'staff.profile.tax.taxRegistrationDate': 'Ngày đăng ký thuế',
    'staff.profile.tax.taxAuthority': 'Cơ quan thuế',
    'staff.profile.tax.taxResidency': 'Cư trú thuế',
    'staff.profile.tax.taxStatus': 'Trạng thái hồ sơ thuế',
    'staff.profile.tax.socialInsuranceNumber': 'Số BHXH',
    'staff.profile.tax.healthInsuranceNumber': 'Số BHYT',
    'staff.profile.tax.insuranceRegistrationDate': 'Ngày tham gia BHXH',
    'staff.profile.tax.insurancePlace': 'Nơi đăng ký BHXH',
    'staff.profile.tax.insuranceStatus': 'Trạng thái BHXH',
    'staff.profile.tax.section': 'Thông tin thuế',
    'staff.profile.tax.insuranceSection': 'Thông tin BHXH/BHYT',
    'staff.profile.tax.enableSection': 'Bật',

    'staff.profile.document.documentType': 'Loại tài liệu',
    'staff.profile.document.documentType.CV': 'CV',
    'staff.profile.document.documentType.PHOTO': 'Ảnh',
    'staff.profile.document.documentType.DEGREE': 'Bằng cấp',
    'staff.profile.document.documentType.CERTIFICATE': 'Chứng chỉ',
    'staff.profile.document.documentType.OTHER': 'Khác',
    'staff.profile.document.documentName': 'Tên tài liệu',
    'staff.profile.document.fileUrl': 'File tài liệu',
    'staff.profile.document.fileName': 'Tên file',
    'staff.profile.document.mimeType': 'Định dạng file',
    'staff.profile.document.fileSize': 'Kích thước (byte)',
    'staff.profile.document.issueDate': 'Ngày cấp',
    'staff.profile.document.expiryDate': 'Ngày hết hạn',
    'staff.profile.document.issuingOrganization': 'Đơn vị cấp',
    'staff.profile.document.documentNumber': 'Số tài liệu',
    'staff.profile.document.validation.fileUrl': 'Đường dẫn file không hợp lệ',
    'staff.profile.document.validation.mimeType':
      'Định dạng file không hợp lệ, ví dụ: application/pdf',
    'staff.profile.document.validation.expiryAfterIssue': 'Ngày hết hạn phải từ ngày cấp trở đi',
    'staff.profile.document.upload.select': 'Chọn tệp',
    'staff.profile.document.upload.replace': 'Thay tệp',
    'staff.profile.document.upload.clear': 'Xóa tệp đã chọn',
    'staff.profile.document.upload.invalidType':
      'Chỉ hỗ trợ ảnh (jpg, jpeg, png, webp), PDF và Office (doc, docx, xls, xlsx)',
    'staff.profile.document.upload.tooLarge': 'Kích thước tệp vượt quá {max}MB',
    'staff.profile.document.upload.failed': 'Tải tệp lên thất bại, vui lòng thử lại',

    'staff.profile.consent.consentType': 'Loại xác nhận',
    'staff.profile.consent.version': 'Phiên bản',
    'staff.profile.consent.status': 'Trạng thái',
    'staff.profile.consent.status.ACCEPTED': 'Đã chấp nhận',
    'staff.profile.consent.status.REVOKED': 'Đã thu hồi',
    'staff.profile.consent.status.PENDING': 'Chờ xác nhận',
    'staff.profile.consent.acceptedAt': 'Xác nhận lúc',
    'staff.profile.consent.revokedAt': 'Thu hồi lúc',
    'staff.profile.consent.source': 'Nguồn',
    'staff.profile.consent.source.WEB': 'Web',
    'staff.profile.consent.source.MOBILE': 'Mobile',
    'staff.profile.consent.source.PAPER': 'Giấy tờ',
    'staff.profile.consent.source.OTHER': 'Khác',
    'staff.profile.consent.notes': 'Ghi chú',
    'staff.profile.consent.validation.consentType':
      'Loại xác nhận chỉ gồm chữ, số, dấu cách, dấu gạch dưới và dấu gạch ngang',
    'staff.profile.consent.validation.version': 'Phiên bản phải ở dạng 1, 1.0 hoặc 1.0.0',

    'staff.profile.validation.emailInvalid': 'Email không hợp lệ.',
    'staff.profile.validation.requiredField': '{field} là bắt buộc.',
    'staff.profile.validation.dateOrder': 'Ngày kết thúc phải sau ngày bắt đầu.',
  },
  en: {
    'staff.profile.title': 'Staff Profile',
    'staff.profile.backToList': 'Staff List',
    'staff.profile.loadFailed': 'Failed to load staff profile.',
    'staff.profile.detail.workSection': 'Work Information',
    'staff.profile.detail.systemSection': 'System Information',
    'staff.profile.detail.navigationTitle': 'Profile sections',
    'staff.profile.detail.createdAt': 'Created at',
    'staff.profile.detail.updatedAt': 'Updated at',
    'staff.profile.detail.yes': 'Yes',
    'staff.profile.detail.no': 'No',
    'staff.profile.detail.compensationSection': 'Salary & allowances',
    'staff.profile.detail.allowances': 'Allowances',
    'staff.profile.detail.healthInsurance': 'Health insurance',
    'staff.profile.detail.unemploymentInsurance': 'Unemployment insurance',
    'staff.profile.tab.personal': 'Personal Information',
    'staff.profile.tab.identityDocuments': 'Identity Documents',
    'staff.profile.tab.addresses': 'Addresses',
    'staff.profile.tab.emergencyContacts': 'Emergency Contacts',
    'staff.profile.tab.familyMembers': 'Family',
    'staff.profile.tab.bankAccounts': 'Bank Accounts',
    'staff.profile.tab.taxInsurance': 'Tax & Social Insurance',
    'staff.profile.tab.documents': 'Documents',
    'staff.profile.tab.consents': 'Consents',

    'staff.profile.actions.add': 'Add',
    'staff.profile.actions.edit': 'Edit',
    'staff.profile.actions.delete': 'Delete',
    'staff.profile.actions.verify': 'Verify',
    'staff.profile.actions.verified': 'Verified',
    'staff.profile.actions.refresh': 'Refresh',
    'staff.profile.actions.save': 'Save',
    'staff.profile.actions.savePersonal': 'Save Personal Information',
    'staff.profile.actions.saveTax': 'Save Tax Information',
    'staff.profile.actions.saveInsurance': 'Save Social Insurance Information',
    'staff.profile.actions.addTitle.identity_documents': 'Add Identity Document',
    'staff.profile.actions.editTitle.identity_documents': 'Edit Identity Document',
    'staff.profile.actions.addTitle.addresses': 'Add Address',
    'staff.profile.actions.editTitle.addresses': 'Edit Address',
    'staff.profile.actions.addTitle.emergency_contacts': 'Add Emergency Contact',
    'staff.profile.actions.editTitle.emergency_contacts': 'Edit Emergency Contact',
    'staff.profile.actions.addTitle.family_members': 'Add Family Member',
    'staff.profile.actions.editTitle.family_members': 'Edit Family Member',
    'staff.profile.actions.addTitle.bank_accounts': 'Add Bank Account',
    'staff.profile.actions.editTitle.bank_accounts': 'Edit Bank Account',
    'staff.profile.actions.addTitle.documents': 'Add Document',
    'staff.profile.actions.editTitle.documents': 'Edit Document',
    'staff.profile.actions.addTitle.consents': 'Add Consent',
    'staff.profile.actions.editTitle.consents': 'Edit Consent',
    'staff.profile.actions.deleteConfirm.identity_documents': 'Delete this identity document?',
    'staff.profile.actions.deleteConfirm.addresses': 'Delete this address?',
    'staff.profile.actions.deleteConfirm.emergency_contacts': 'Delete this emergency contact?',
    'staff.profile.actions.deleteConfirm.family_members': 'Delete this family member?',
    'staff.profile.actions.deleteConfirm.bank_accounts': 'Delete this bank account?',
    'staff.profile.actions.deleteConfirm.documents': 'Delete this document?',
    'staff.profile.actions.deleteConfirm.consents': 'Delete this consent?',
    'staff.profile.actions.verifyConfirm.identity_documents':
      'Verify that this identity document is correct?',
    'staff.profile.actions.verifyConfirm.bank_accounts':
      'Verify that this bank account is correct?',
    'staff.profile.actions.verifyConfirm.documents': 'Verify that this document is correct?',

    'staff.profile.common.isPrimary': 'Set as primary',
    'staff.profile.common.primary': 'Primary',
    'staff.profile.common.notPrimary': 'Secondary',
    'staff.profile.common.verifiedAt': 'Verified at',
    'staff.profile.common.empty': 'No data yet',
    'staff.profile.common.required': 'This field is required.',

    'staff.profile.personal.legalName': 'Legal name',
    'staff.profile.personal.firstName': 'First name',
    'staff.profile.personal.lastName': 'Last name',
    'staff.profile.personal.placeOfBirth': 'Place of birth',
    'staff.profile.personal.maritalStatus': 'Marital status',
    'staff.profile.personal.maritalStatus.single': 'Single',
    'staff.profile.personal.maritalStatus.married': 'Married',
    'staff.profile.personal.maritalStatus.divorced': 'Divorced',
    'staff.profile.personal.maritalStatus.widowed': 'Widowed',
    'staff.profile.personal.nationality': 'Nationality',
    'staff.profile.personal.ethnicity': 'Ethnicity',
    'staff.profile.personal.religion': 'Religion',
    'staff.profile.personal.personalEmail': 'Personal email',
    'staff.profile.personal.personalPhone': 'Personal phone',
    'staff.profile.personal.note':
      'Personal contact data is encrypted before being stored in the system.',
    'staff.profile.personal.fillFromGeneral': 'Fill from general info',

    'staff.profile.identity.documentType': 'Document type',
    'staff.profile.identity.documentType.CCCD': 'Citizen ID Card',
    'staff.profile.identity.documentType.CMND': 'ID Card',
    'staff.profile.identity.documentType.PASSPORT': 'Passport',
    'staff.profile.identity.documentType.OTHER': 'Other',
    'staff.profile.identity.documentNumber': 'Document number',
    'staff.profile.identity.fullNameOnDocument': 'Full name on document',
    'staff.profile.identity.dateOfBirthOnDocument': 'Date of birth on document',
    'staff.profile.identity.genderOnDocument': 'Gender on document',
    'staff.profile.identity.issueDate': 'Issue date',
    'staff.profile.identity.expiryDate': 'Expiry date',
    'staff.profile.identity.issuePlace': 'Issue place',
    'staff.profile.identity.issuingAuthority': 'Issuing authority',
    'staff.profile.identity.frontUrl': 'Front image',
    'staff.profile.identity.backUrl': 'Back image',
    'staff.profile.identity.validation.expiryAfterIssue':
      'Expiry date must be on or after issue date',
    'staff.profile.identity.validation.documentNumber':
      'Document number may only contain letters, numbers, dashes and dots',
    'staff.profile.identity.attachments': 'Attached images',
    'staff.profile.identity.upload.addPhoto': 'Add photo',
    'staff.profile.identity.upload.select': 'Select photo',
    'staff.profile.identity.upload.replace': 'Replace photo',
    'staff.profile.identity.upload.clear': 'Remove photo',
    'staff.profile.identity.upload.invalidType': 'Only JPG, PNG, WEBP images are supported',
    'staff.profile.identity.upload.fileTooLarge': 'Each image must be under {max}MB',
    'staff.profile.identity.upload.totalTooLarge': 'Total image size exceeds {max}MB',
    'staff.profile.identity.upload.maxFiles': 'Maximum {max} images',
    'staff.profile.identity.upload.failed': 'Photo upload failed, please try again',

    'staff.profile.address.addressType': 'Address type',
    'staff.profile.address.addressType.PERMANENT': 'Permanent',
    'staff.profile.address.addressType.CURRENT': 'Current',
    'staff.profile.address.addressType.MAILING': 'Mailing',
    'staff.profile.address.addressType.OTHER': 'Other',
    'staff.profile.address.addressLine': 'Address line',
    'staff.profile.address.ward': 'Ward',
    'staff.profile.address.district': 'District',
    'staff.profile.address.province': 'Province',
    'staff.profile.address.country': 'Country',
    'staff.profile.address.postalCode': 'Postal code',
    'staff.profile.address.effectiveFrom': 'Effective from',
    'staff.profile.address.effectiveTo': 'Effective to',
    'staff.profile.address.validation.effectiveRange':
      'Effective to must be on or after effective from',
    'staff.profile.address.validation.postalCode': 'Postal code may only contain digits',

    'staff.profile.emergency.fullName': 'Full name',
    'staff.profile.emergency.relationship': 'Relationship',
    'staff.profile.emergency.phone': 'Phone number',
    'staff.profile.emergency.alternatePhone': 'Alternate phone',
    'staff.profile.emergency.email': 'Email',
    'staff.profile.emergency.address': 'Address',
    'staff.profile.emergency.priority': 'Priority',
    'staff.profile.emergency.notes': 'Notes',

    'staff.profile.family.fullName': 'Full name',
    'staff.profile.family.relationship': 'Relationship',
    'staff.profile.family.gender': 'Gender',
    'staff.profile.family.dateOfBirth': 'Date of birth',
    'staff.profile.family.nationality': 'Nationality',
    'staff.profile.family.occupation': 'Occupation',
    'staff.profile.family.phone': 'Phone number',
    'staff.profile.family.address': 'Address',
    'staff.profile.family.isDependent': 'Is dependent',
    'staff.profile.family.dependentFrom': 'Dependent from',
    'staff.profile.family.dependentTo': 'Dependent to',
    'staff.profile.family.notes': 'Notes',
    'staff.profile.family.validation.dependentRange':
      'Dependent to must be on or after dependent from',

    'staff.profile.bank.bankName': 'Bank name',
    'staff.profile.bank.bankCode': 'Bank code',
    'staff.profile.bank.branchName': 'Branch',
    'staff.profile.bank.accountNumber': 'Account number',
    'staff.profile.bank.accountHolderName': 'Account holder name',
    'staff.profile.bank.currency': 'Currency',
    'staff.profile.bank.validation.accountNumber': 'Account number may only contain digits',

    'staff.profile.tax.taxIdentificationNumber': 'Tax identification number',
    'staff.profile.tax.taxRegistrationDate': 'Tax registration date',
    'staff.profile.tax.taxAuthority': 'Tax authority',
    'staff.profile.tax.taxResidency': 'Tax residency',
    'staff.profile.tax.taxStatus': 'Tax status',
    'staff.profile.tax.socialInsuranceNumber': 'Social insurance number',
    'staff.profile.tax.healthInsuranceNumber': 'Health insurance number',
    'staff.profile.tax.insuranceRegistrationDate': 'Insurance registration date',
    'staff.profile.tax.insurancePlace': 'Insurance place',
    'staff.profile.tax.insuranceStatus': 'Insurance status',
    'staff.profile.tax.section': 'Tax Information',
    'staff.profile.tax.insuranceSection': 'Social / Health Insurance',
    'staff.profile.tax.enableSection': 'Enable',

    'staff.profile.document.documentType': 'Document type',
    'staff.profile.document.documentType.CV': 'CV',
    'staff.profile.document.documentType.PHOTO': 'Photo',
    'staff.profile.document.documentType.DEGREE': 'Degree',
    'staff.profile.document.documentType.CERTIFICATE': 'Certificate',
    'staff.profile.document.documentType.OTHER': 'Other',
    'staff.profile.document.documentName': 'Document name',
    'staff.profile.document.fileUrl': 'Document file',
    'staff.profile.document.fileName': 'File name',
    'staff.profile.document.mimeType': 'MIME type',
    'staff.profile.document.fileSize': 'Size (bytes)',
    'staff.profile.document.issueDate': 'Issue date',
    'staff.profile.document.expiryDate': 'Expiry date',
    'staff.profile.document.issuingOrganization': 'Issuing organization',
    'staff.profile.document.documentNumber': 'Document number',
    'staff.profile.document.validation.fileUrl': 'Invalid file path',
    'staff.profile.document.validation.mimeType': 'Invalid MIME type, for example application/pdf',
    'staff.profile.document.validation.expiryAfterIssue':
      'Expiry date must be on or after issue date',
    'staff.profile.document.upload.select': 'Select file',
    'staff.profile.document.upload.replace': 'Replace',
    'staff.profile.document.upload.clear': 'Remove selected file',
    'staff.profile.document.upload.invalidType':
      'Only images (jpg, jpeg, png, webp), PDF and Office files (doc, docx, xls, xlsx) are supported',
    'staff.profile.document.upload.tooLarge': 'File size exceeds {max}MB',
    'staff.profile.document.upload.failed': 'File upload failed, please try again',

    'staff.profile.consent.consentType': 'Consent type',
    'staff.profile.consent.version': 'Version',
    'staff.profile.consent.status': 'Status',
    'staff.profile.consent.status.ACCEPTED': 'Accepted',
    'staff.profile.consent.status.REVOKED': 'Revoked',
    'staff.profile.consent.status.PENDING': 'Pending',
    'staff.profile.consent.acceptedAt': 'Accepted at',
    'staff.profile.consent.revokedAt': 'Revoked at',
    'staff.profile.consent.source': 'Source',
    'staff.profile.consent.source.WEB': 'Web',
    'staff.profile.consent.source.MOBILE': 'Mobile',
    'staff.profile.consent.source.PAPER': 'Paper',
    'staff.profile.consent.source.OTHER': 'Other',
    'staff.profile.consent.notes': 'Notes',
    'staff.profile.consent.validation.consentType':
      'Consent type may only contain letters, numbers, spaces, dots, dashes and underscores',
    'staff.profile.consent.validation.version': 'Version must look like 1, 1.0 or 1.0.0',

    'staff.profile.validation.emailInvalid': 'Invalid email address.',
    'staff.profile.validation.requiredField': '{field} is required.',
    'staff.profile.validation.dateOrder': 'End date must be after start date.',
  },
}
